export async function getConf() {
	try {
		const response = await fetch('/runtime_conf.json');
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		// Parse the JSON response
		const data = await response.json();
		return data; // Return the fetched data for further use
	} catch (error) {
		console.error('Error fetching runtime_conf.json:', error);
		return error;
	}
}
